import React, { useEffect, useRef } from "react";
import { createContext } from "react";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, addDoc, collection } from "firebase/firestore";
import toast from "react-hot-toast";

const costs = {
  ["Foundation Level"]: {
    ["IB DP"]: {
      ["8-Hour"]: 285,
      ["12-Hour"]: 430,
      ["16-Hour"]: 575,
      ["hourly"]: 35.99,
    },
    ["IB MYP"]: {
      ["8-Hour"]: 210,
      ["12-Hour"]: 325,
      ["16-Hour"]: 430,
      ["hourly"]: 26.99,
    },
    ["Others"]: {
      ["8-Hour"]: 200,
      ["12-Hour"]: 300,
      ["16-Hour"]: 400,
      ["hourly"]: 24.99,
    },
  },

  ["Advance Level"]: {
    ["IB DP"]: {
      ["8-Hour"]: 390,
      ["12-Hour"]: 585,
      ["16-Hour"]: 780,
      ["hourly"]: 48.99,
    },
    ["IB MYP"]: {
      ["8-Hour"]: 290,
      ["12-Hour"]: 440,
      ["16-Hour"]: 580,
      ["hourly"]: 36.99,
    },
    ["Others"]: {
      ["8-Hour"]: 270,
      ["12-Hour"]: 405,
      ["16-Hour"]: 545,
      ["hourly"]: 33.99,
    },
  },

  ["Expert Level"]: {
    ["IB DP"]: {
      ["8-Hour"]: 455,
      ["12-Hour"]: 685,
      ["16-Hour"]: 910,
      ["hourly"]: 56.99,
    },
    ["IB MYP"]: {
      ["8-Hour"]: 340,
      ["12-Hour"]: 510,
      ["16-Hour"]: 680,
      ["hourly"]: 41.99,
    },
    ["Others"]: {
      ["8-Hour"]: 315,
      ["12-Hour"]: 475,
      ["16-Hour"]: 635,
      ["hourly"]: 39.99,
    },
  },

  ["Guidance And Support"]: 55,
};

export const RegisterFormContext = createContext({
  formData: {
    program: "",
    class: "",
    selectedSubjects: [],
    tutoringSupport: "",
    package: "",
    hours: 0,
    lessonDates: [],
    timeZone: "",
    guidanceAndSupport: {
      needed: false,
      assignmentType: "",
      query: "",
      hours: 0,
    },
    userDetails: {
      firstName: "",
      lastName: "",
      email: "",
      relation: "",
      parentFirstName: "",
      parentLastName: "",
      parentEmail: "",
    },
    billingInfo: {
      fullName: "",
      email: "",
      contactNo: "",
    },
    totalCost: 0,
    totalCostAfterGuidanceAndSupport: 0,
  },
  setFormData: () => {},
  availableScreens: {
    screen1: false,
    screen2: false,
    screen3: false,
    screen4: false,
    screen5: false,
    screen6: false,
    screen7: false,
    screen8: false,
    screen9: false,
    screen19: false,
  },
  setAvailableScreens: () => {},
  costs: costs,
  submitForm: () => {},
});

export const RegisterFormContextProvider = ({ children }) => {
  
  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState({
    program: "",
    class: "",
    selectedSubjects: [],
    tutoringSupport: "",
    package: "",
    hours: 0,
    lessonDates: [],
    timeZone: "",
    guidanceAndSupport: {
      needed: false,
      assignmentType: [],
      query: "",
      hours: 0,
    },
    userDetails: {
      firstName: "",
      lastName: "",
      email: "",
      relation: "",
      parentFirstName: "",
      parentLastName: "",
      parentEmail: "",
    },
    billingInfo: {
      fullName: "",
      email: "",
      contactNo: "",
    },
    totalCost: 0,
    totalCostAfterGuidanceAndSupport: 0
  });

  useEffect(() => {
    const program = searchParams.get("program") || "";
    const packageType = searchParams.get("package") || "";
    const hours = searchParams.get("hours") || "";
    const tutorType = searchParams.get("tutorType") || "";
  
    const newFormData = {
      program,
      package: packageType,
      hours,
      tutoringSupport: tutorType,
    };
  
    setFormData((prevFormData) => {
      if (
        prevFormData.program === program &&
        prevFormData.package === packageType &&
        prevFormData.hours === hours &&
        prevFormData.tutoringSupport === tutorType
      ) {
        return prevFormData; // Avoid unnecessary re-renders
      }
      return { ...prevFormData, ...newFormData };
    });
  }, [searchParams]);

  const [availableScreens, setAvailableScreens] = useState({
    screen1: false,
    screen2: false,
    screen3: false,
    screen4: false,
    screen5: false,
    screen6: false,
    screen7: false,
    screen8: false,
    screen9: false,
    screen19: false,
  });

  const zero = useRef();
  const one = useRef();
  const two = useRef();
  const three = useRef();
  const four = useRef();
  const five = useRef();
  const six = useRef();
  const seven = useRef();
  const eight = useRef();
  const nine = useRef();
  const ten = useRef();


  const [loading, setLoading] = useState(false);
  const submitForm = async () => {
    setLoading(true)
    try {
      await addDoc(
        collection(db, "adminPanel", "studentForm", "studentForm"),
        {...formData, submittedAt: new Date(),
          type: "new"}
      );
      toast.success("Form submitted successfully!");
  
      // Reset formData to default values
      setFormData({
        program: "",
        class: "",
        selectedSubjects: [],
        tutoringSupport: "",
        package: "",
        hours: 0,
        lessonDates: [],
        timeZone: "",
        guidanceAndSupport: {
          needed: false,
          assignmentType: [],
          query: "",
          hours: 0,
        },
        userDetails: {
          firstName: "",
          lastName: "",
          email: "",
          relation: "",
          parentFirstName: "",
          parentLastName: "",
          parentEmail: "",
        },
        billingInfo: {
          fullName: "",
          email: "",
          contactNo: "",
        },
        totalCost: 0,
        totalCostAfterGuidanceAndSupport: 0
      });
      setAvailableScreens({
        screen1: false,
        screen2: false,
        screen3: false,
        screen4: false,
        screen5: false,
        screen6: false,
        screen7: false,
        screen8: false,
        screen9: false,
        screen19: false,
      })
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit form. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <RegisterFormContext.Provider
      value={{
        formData,
        setFormData,
        zero,
        one,
        two,
        three,
        four,
        five,
        six,
        seven,
        eight,
        nine,
        ten,
        costs,
        availableScreens,
        setAvailableScreens,
        submitForm,
        loading
      }}
    >
      {children}
    </RegisterFormContext.Provider>
  );
};
